import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { User } from "../types";

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  user: User | null;
  set: (data: { accessToken: string; refreshToken: string; user?: User | null }) => void;
  setUser: (user: User | null) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      // Si no se pasa user, se conserva el actual. Asi evitamos un render
      // intermedio con user=null entre el login y la posterior llamada a me().
      set: ({ accessToken, refreshToken, user }) =>
        set((s) => ({
          accessToken,
          refreshToken,
          user: user === undefined ? s.user : user,
        })),
      setUser: (user) => set({ user }),
      clear: () => set({ accessToken: null, refreshToken: null, user: null }),
    }),
    { name: "vms-auth" },
  ),
);
